var LocalityViewModal = (function (base) {
  __extends(LocalityViewModal, base);

  function LocalityViewModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };

  LocalityViewModal.prototype.activate = function (localityId, showOnMapFunc) {
    const self = this;
    const url = `api/localities/${localityId}`;

    this.loadContent(url)
      .then($modal => {

        $modal

          //Кнопка `Редактировать`
          .on('click', '[js=edit]', function () {
            ModalConductor.activate(LocalityEditModal, localityId)
              .on('closed', (modalResult) => {
                if (modalResult.ok) {
                  self.reloadContent(url);
                }
              });
          })

          //Кнопка `Показать на карте`
          .on('click', '[js=show-on-map]', function () {
            showOnMapFunc(localityId);
          })

        //Кнопка "История метеоданных"
        .on('click', '[js=show-history]', function () {
          const localityName = $('[data-binding=Name]', $modal).text(); console.debug(localityName);
          ModalConductor.activate(LocalityHistoryModal, localityId, localityName);
        });
      });
  };

  return LocalityViewModal;
}(BaseModal));
